// Created by hejikun on 2017/10/25 0025.
import AppCache from '../../utils/AppCache'
import config from '@/library/config'
import { getDoctorDetail } from '@/apis/fromBaseApi/doctor'

const registrationCache = new AppCache()
let state = {
  hos_detail: {},
  registration_hos_detail: [],
  registration_order: {},
  registration_hasMore: false,
  registration_hospital_detail: {},
  docDetail: 0,
  subspecialty_name: '',
  cate_name: '',
  registration_dep_detail: 0,
  registration_depart_list: [],
  registration_adviser_list: 0,
  registration_latelys_list: [],
  registration_select_patients: [], // 就诊人选择列表
  registration_select_patient: {}, // 已选择的就诊人
  registration_floor: [], // 楼层分布
  is_follow: {
    result: ''
  }, // 关注状态
  registration_stop: [], // 停诊通知
  registration_report_list: [], // 检验检查报告
  registration_report_detail: [], // 检验检查详情
  registration_report_info: {}, // 检验检查信息
  registration_unpay_list: [], // 在线缴费未支付列表
  registration_unpay_item: {}, // 在线缴费项目
  registration_hospital_list: [], // 医院列表
  registration_hospital_all_list: [], // 新版医院列表
  registration_hospital_type_list: [], // 医院类型列表
  registration_invitation_list: [], // 就医攻略聊表
  registration_reply_list: [], // 攻略回复列表
  registration_cancer_form: {}, // 肿瘤基因筛查受检人信息
  registration_cancer_sample: {}, // 肿瘤基因筛查送检样本信息
  registration_examine_order: [], // 检查预约订单详情
  registration_gongren_extra_dep: {},
  docDetail_new: {}
}
let host = ''
if (window.location.hostname.indexOf('appv3.ynhdkc.com') > -1) {
  host = 'https://newdytapi.ynhdkc.com'
} else {
  host = 'https://newdytapi.ynhdkc.com'
}
const actions = {
  // 获取列表
  loadRegistrationList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'registration_hospital_list': // 获取医院列表
        url = `/v1/hospital`
        break
      case 'registration_hospital_all_list': // 获取医院列表
        if (args.platform) {
          url = `${host}/index/allhospital?cate_id=${args.cate_id}&platform=${args.platform}`
        } else {
          url = `${host}/index/allhospital?cate_id=${args.cate_id}`
          const hospitalList = registrationCache.getValue('registration_hospital_all_list', args.cate_id)
          if (hospitalList) {
            commit({
              type: 'set_registration_list',
              dataType: args.type,
              data: hospitalList,
              page: args.page
            })
            return Promise.resolve(hospitalList)
          }
        }
        break
      case 'registration_hospital_type_list': // 获取医院类型列表
        if (state.registration_hospital_type_list.length > 0) {
          return new Promise((resolve, reject) => {
            resolve(state.registration_hospital_type_list)
          })
        }
        url = `${host}/index/hospital/hoscate`
        break
      case 'registration_invitation_list': // 获取攻略列表
        url = `/v2/topic?hos_id=${args.hos_id}&page=${args.page}&page_num=${args.page_num}&kw=${args.kw}`
        break
      case 'registration_depart_list': {
        // 获取科室列表
        url = `${host}/index/hospital/${args.hos_code}/depart`
        const departList = registrationCache.getValue('registration_depart_list', args.hos_code)
        if (departList) {
          commit({
            type: 'set_registration_list',
            dataType: args.type,
            data: departList,
            page: args.page
          })
          return Promise.resolve(departList)
        }
        break
      }
      case 'registration_latelys_list': {
        // 获取科室列表
        url = `${host}/index/lastdeparts?hos_id=${args.hos_code}&user_id=${args.user_id}`
        const latelyDepartList = registrationCache.getValue('registration_latelys_list', args.hos_code)
        if (latelyDepartList) {
          commit({
            type: 'set_registration_list',
            dataType: args.type,
            data: latelyDepartList,
            page: args.page
          })
          return Promise.resolve(latelyDepartList)
        }
        break
      }
      case 'registration_reply_list': // 获取攻略列表
        url = `/v2/topicreply?topic_id=${args.topic_id}&page=${args.page}&page_num=${args.page_num}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    return window.axiosBaseApi
      .get(url)
      .then((res) => {
        if (res.data.code === 1) {
          if (res.data.date_list) {
            // 医生列表时间
            commit({
              type: 'set_registration_list',
              dataType: args.type,
              data: res.data,
              page: args.page
            })
          } else {
            if (args.type === 'registration_hospital_all_list' && !args.platform) {
              registrationCache.addCache('registration_hospital_all_list', args.cate_id, res.data.data, 900)
            }
            if (args.type === 'registration_latelys_list') {
              registrationCache.addCache('registration_latelys_list', args.hos_code, res.data.data, 300)
            }
            if (args.type === 'registration_depart_list') {
              registrationCache.addCache('registration_depart_list', args.hos_code, res.data.data, 900)
            }
            commit({
              type: 'set_registration_list',
              dataType: args.type,
              data: res.data.data,
              page: args.page
            })
          }
        } else {
          commit({
            type: 'set_registration_list',
            dataType: args.type,
            data: res.data.data,
            page: args.page
          })
        }
        return Promise.resolve(res.data.data)
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  },
  // 获取详情
  loadHosDetail({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'registration_hospital_detail': {
        // 获取医院详情
        url = `${host}/index/hospital/${args.hos_code}`
        const hosDetail = registrationCache.getValue('registration_hospital_detail', args.hos_code)
        if (hosDetail) {
          commit({
            type: 'set_detail',
            dataType: args.type,
            data: hosDetail
          })
          return Promise.resolve(hosDetail)
        }
        break
      }

      case 'docDetail': {
        // 获取医生详情
        let docId = args.id
        if (docId.indexOf('/') >= 0) {
          docId = docId.replace(/\//g, '___')
        }
        url = `${host}/index/doctor/${docId}?hos_code=${args.hos_code}&dep_id=${args.dep_id}`
        break
      }
      case 'docDetail_new': {
        // 获取医生详情

        getDoctorDetail(
          {
            department_id: args.department_id,
            hospital_area_id: args.hospital_area_id,
            hospital_id: args.hospital_id
          },
          args.id
        ).then((res) => {
          if (res.status === 200) {
            commit({
              type: 'set_detail',
              dataType: args.type,
              data: res.data
            })
            return Promise.resolve(res.data)
          } else {
            commit({
              type: 'set_detail',
              dataType: args.type,
              data: {}
            })
            return Promise.resolve([])
          }
        })
        break
      }
      case 'registration_dep_detail': // 获取科室详情
        url = `${host}/index/hospital/${args.hos_code}/depart/${args.dep_id}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    if (url) {
      window.axiosBaseApi
        .get(url)
        .then((res) => {
          if (res.data.code === 1) {
            console.log(res)
            if (args.type === 'registration_hospital_detail') {
              registrationCache.addCache('registration_hospital_detail', args.hos_code, res.data.data, 3600)
            }
            commit({
              type: 'set_detail',
              dataType: args.type,
              data: res.data.data
            })
            return Promise.resolve(res.data.data)
          } else {
            commit({
              type: 'set_detail',
              dataType: args.type,
              data: {}
            })
            return Promise.resolve([])
          }
        })
        .catch((e) => {
          return Promise.reject(e)
        })
    }
  }
}

const getters = {
  registration_compute_hos_menu(state) {
    const detail = state.registration_hospital_detail
    let compMenus = []
    let hosId = state.registration_hospital_detail.hos_id
    for (let value in detail) {
      let menu = {}
      switch (value) {
        case 'status':
          menu.state = [0, 2].indexOf(detail[value]) === -1
          menu.name = '预约挂号'
          menu.img = '/static/img/hospital/registration2.png'
          menu.path = ''
          menu.index = 1
          compMenus.push(menu)
          break
        case 'treat_wait':
          menu.state = detail[value]
          menu.name = '候诊查询'
          menu.img = '/static/img/hospital/waite2.png'
          menu.index = 3
          menu.path = `/registration_treat_wait?hos_code=${hosId}`
          compMenus.push(menu)
          break
        /* case 'depart_pay':
          menu.state = detail[value]
          menu.name = '诊间缴费'
          menu.img = '/static/img/hospital/pay.png'
          menu.path = `/registration_online_payment?id=${hosId}`
          compMenus.push(menu)
          break */
        case 'is_guide':
          menu.state = detail[value]
          menu.name = '智能导诊'
          menu.img = '/static/img/hospital/daozhen.png'
          // menu.path = `/guidance_index?hos_code=${hosId}`
          menu.path = `/hospital_guide?clinic_id=${hosId}&sex=0&age=0`
          compMenus.push(menu)
          break
        case 'report':
          menu.state = detail[value]
          menu.name = '报告单查询'
          menu.img = '/static/img/hospital/report_search2.png'
          menu.path = `/registration_report?id=${hosId}`
          menu.index = 2
          compMenus.push(menu)
          break
        case 'takeno_guide':
          menu.state = detail[value] && detail[value] !== '' ? 1 : -1
          menu.name = '取号指南'
          menu.img = '/static/img/hospital/take_number2.png'
          menu.path = `/registration_guide?id=${hosId}`
          menu.index = 8
          compMenus.push(menu)
          break
        case 'hospital_rule':
          menu.state = detail[value] && detail[value] !== '' ? 1 : 0
          menu.name = '预约规则'
          menu.img = '/static/img/hospital/rule2.png'
          menu.path = `/registration_rule?id=${hosId}`
          menu.index = 9
          compMenus.push(menu)
          break
        case 'baidu_map_keywords':
          menu.state = detail[value] && detail[value] !== '' ? 1 : -1
          menu.name = '去院导航'
          menu.img = '/static/img/hospital/navigation2.png'
          menu.index = 11
          compMenus.push(menu)
          break
        case 'floor_open':
          menu.state = detail[value]
          menu.name = '楼层分布'
          menu.img = '/static/img/hospital/floor2.png'
          menu.path = `/registration_floor_open?id=${hosId}`
          menu.index = 10
          compMenus.push(menu)
          break
        /* case 'hospital_phone':
          menu.state = detail[value] && detail[value] !== '' ? 1 : 0
          menu.name = '医院电话'
          menu.img = '/static/img/hospital/phone.png'
          menu.index = 8
          compMenus.push(menu)
          break */
        case 'mz_recharge':
          menu.state = detail[value] || 0
          menu.name = '就诊卡充值'
          menu.img = '/static/img/hospital/recharge2.png'
          menu.index = 5
          menu.href = window.$isTest
            ? `https://test.ynhdkc.com/register_pay?hos_code=${hosId}&jwt=${config.token}&wechat_login=${config.from}`
            : `https://app.ynhdkc.com/register_pay?hos_code=${hosId}&jwt=${config.token}&wechat_login=${config.from}&isNewToken=1`
          compMenus.push(menu)
          break
        case 'inhospital_pay':
          menu.state = detail[value] || 0
          menu.name = '住院缴费'
          menu.img = '/static/img/hospital/hospital_pay2.png'
          menu.index = 4
          menu.href = window.$isTest
            ? `https://test.ynhdkc.com/inhospital_pay?hos_code=${hosId}&jwt=${config.token}&wechat_login=${config.from}`
            : `https://app.ynhdkc.com/inhospital_pay?hos_code=${hosId}&jwt=${config.token}&wechat_login=${config.from}&isNewToken=1`
          compMenus.push(menu)
          break
        case 'stop':
          menu.state = detail[value]
          menu.name = '停诊通知'
          menu.img = '/static/img/hospital/stop_service2.png'
          menu.index = 7
          menu.path = `/registration_stop?id=${hosId}`
          compMenus.push(menu)
          break
        // case 'card_reported_loss':
        //   menu.state = detail[value]
        //   menu.name = '就诊卡挂失'
        //   menu.href = window.$isTest
        //     ? `https://test.ynhdkc.com/card_reported_loss?hos_code=${hosId}&jwt=${config.token}&wechat_login=${config.from}`
        //     : `https://app.ynhdkc.com/card_reported_loss?hos_code=${hosId}&jwt=${config.token}&wechat_login=${config.from}&isNewToken=1`
        //   menu.img = '/static/img/hospital/lost2.png'
        //   menu.index = 6
        //   compMenus.push(menu)
        //   break
      }
    }
    return compMenus
  },
  registration_order(args) {
    return args.registration_order
  },
  // 重新计算停诊通知数据
  registration_compute_stop_list(state) {
    // console.log(state.registration_stop)
    let stopList = []
    let i = 0
    for (let time in state.registration_stop) {
      stopList[i] = {
        time: '',
        deps: []
      }
      stopList[i]['time'] = time
      let j = 0
      for (let dep in state.registration_stop[time]) {
        stopList[i]['deps'][j] = {
          depname: '',
          stops: []
        }
        stopList[i]['deps'][j]['depname'] = dep
        stopList[i]['deps'][j]['stops'] = state.registration_stop[time][dep]
        j++
      }
      i++
    }
    return stopList
  }
}

const mutations = {
  set_registration_list(state, args) {
    if (args.dataType === 'registration_depart_list') {
      state[args.dataType] = args.data
    } else if (args.date_list) {
      // 医生列表时间
      state[args.dataType] = {
        data: args.data,
        date_list: args.date_list
      }
    } else {
      if (!args.data) {
        return
      }
      args.data.length < 10 ? (state.ask_hasMore = false) : (state.registration_hasMore = true)
      if (args.page === 1) {
        if ( args.data.length === 0) {
          state[args.dataType] = []
        } else {
          state[args.dataType] = args.data
        }
      } else {
        if ( args.data.length !== 0) {
          args.data.forEach((item) => {
            state[args.dataType].push(item)
          })
        }
      }
    }
  },
  // 设置详情
  set_detail(state, args) {
    state[args.dataType] = args.data
    // console.log(state[args.dataType], 4444)
  },
  // 设置肿瘤基因筛查受检人信息
  set_cancer_form(state, args) {
    state.registration_cancer_form = Object.assign(state.registration_cancer_form, args)
  },
  // 设置肿瘤基因筛查送检样本信息
  set_cancer_sample(state, args) {
    state.registration_cancer_sample = args
  },
  // 存储亚专科的数据
  set_subspecialty_name(state, args) {
    state.subspecialty_name = args
  },
  // 存储急诊
  set_cate_name(state, args) {
    state.cate_name = args
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
